import { render } from "./ClashTestForm.vue?vue&type=template&id=93ac2164&scoped=true&ts=true"
import script from "./ClashTestForm.vue?vue&type=script&lang=ts"
export * from "./ClashTestForm.vue?vue&type=script&lang=ts"

import "./ClashTestForm.vue?vue&type=style&index=0&id=93ac2164&scoped=true&lang=scss"
import "./ClashTestForm.vue?vue&type=style&index=1&id=93ac2164&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93ac2164"]])

export default __exports__